import { Review, StateReview, StatesValues, StateTable } from '@/interfaces';

export const stateTableValues: StatesValues[] = [
	{
		code: StateTable.PROGRAMADA,
		state: 'Programada',
	},
	{
		code: StateTable.DOCUMENTACION_ENVIADA,
		state: 'Documentación enviada',
	},
	{
		code: StateTable.EJECUTADA,
		state: 'Ejecutada',
	},
	{
		code: StateTable.FACTURADA,
		state: 'Facturada',
	},
	{
		code: StateTable.POSTPUESTA,
		state: 'Pospuesta',
	},
	{
		code: StateTable.CANCELADA,
		state: 'Cancelada',
	},
];

export const stateReview: Review[] = [
	{
		name: 'Revisada',
		state: StateReview.REVISED,
	},
	{
		name: 'No revisada',
		state: StateReview.NOT_REVIEWED,
	},
];
